namespace Matrix.Data {
    export interface AccountGroupAccountRow {
        AccountCode?: string;
        AccountGroupCode?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace AccountGroupAccountRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Data.AccountGroupAccount';
        export const deletePermission = 'DataAdmin:AccountGroupAccount';
        export const insertPermission = 'DataAdmin:AccountGroupAccount';
        export const readPermission = 'Read:AccountGroupAccount';
        export const updatePermission = 'DataAdmin:AccountGroupAccount';

        export declare const enum Fields {
            AccountCode = "AccountCode",
            AccountGroupCode = "AccountGroupCode",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
